import Link from "next/link"
import { AlertTriangle, ArrowRight } from "lucide-react"

import type { Problem } from "@/types/problem"
import { getProblemCategoryLabel, getProblemSeverityLabel } from "@/lib/problems"

type ProblemCardProps = {
  problem: Problem
}

export function ProblemCard({ problem }: ProblemCardProps) {
  return (
    <article className="group rounded-[1.75rem] border border-neutral-200 bg-white p-5 shadow-sm transition-transform hover:-translate-y-0.5">
      <div className="flex flex-wrap items-center gap-2">
        <Link
          href={`/problems/category/${problem.category}`}
          className="inline-flex items-center rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-amber-800 transition-colors hover:bg-amber-100"
        >
          <AlertTriangle className="mr-1.5 h-3.5 w-3.5" />
          {getProblemCategoryLabel(problem.category)}
        </Link>

        <span className="inline-flex rounded-full border border-neutral-200 bg-neutral-50 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-neutral-700">
          Ризик: {getProblemSeverityLabel(problem.severity)}
        </span>
      </div>

      <h3 className="mt-4 text-xl font-semibold leading-tight text-neutral-950">
        <Link href={`/problems/${problem.slug}`} className="hover:text-emerald-700">
          {problem.title}
        </Link>
      </h3>

      <p className="mt-3 text-sm leading-7 text-neutral-600">{problem.excerpt}</p>

      <div className="mt-5 rounded-2xl border border-neutral-200 bg-neutral-50 p-4">
        <div className="text-xs font-semibold uppercase tracking-[0.12em] text-neutral-500">
          Швидка відповідь
        </div>

        <p className="mt-2 text-sm leading-7 text-neutral-700">{problem.quickAnswer}</p>
      </div>

      <Link
        href={`/problems/${problem.slug}`}
        className="mt-5 inline-flex items-center text-sm font-semibold text-emerald-700"
      >
        Перейти до рішення
        <ArrowRight className="ml-2 h-4 w-4" />
      </Link>
    </article>
  )
}